export default __webpack_public_path__ + "36a9e0767cf94b99cd7eeeafe8dc6a46.svg";